import { render, staticRenderFns } from "./TransferAssign.vue?vue&type=template&id=77fb9877&scoped=true&"
import script from "./TransferAssign.vue?vue&type=script&lang=js&"
export * from "./TransferAssign.vue?vue&type=script&lang=js&"
import style0 from "./TransferAssign.vue?vue&type=style&index=0&id=77fb9877&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb9877",
  null
  
)

export default component.exports